/*
matchMedia API:
When you use matchMedia, it returns a MediaQueryList object that has a change event that fires whenever the media query state changes. 
So, in this context, the change event is specific to the MediaQueryList interface and not the same as the standard DOM change event.
*/

class BannerVideo extends HTMLElement {

    constructor() {

        super();

        this.mediaQuery = window.matchMedia('(min-width: 49em)');

        this.v_xl_layer = this.querySelector('.video-desktop-layer');
        this.v_sm_layer = this.querySelector('.video-mobile-layer');

        this.v_xl_template = this.querySelector('template.template-video-xl');
        this.v_sm_template = this.querySelector('template.template-video-sm');

        this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this);
        this.handleResize = this.handleResize.bind(this);

        if (!this.v_xl_layer && !this.v_sm_layer && !this.v_xl_template && !this.v_sm_template) {
            this.remove();
        }

    }


    connectedCallback() {
        this.handleMediaQueryChange(this.mediaQuery);
        this.mediaQuery.addEventListener('change', this.handleMediaQueryChange);
        window.addEventListener('resize', this.handleResize);
    }


    handleMediaQueryChange(event) {
        //console.log('Media Query Change Matches:', event.matches);
        event.matches ? this.appendHTMLFromTemplate('d') : this.appendHTMLFromTemplate('m');
    }


    handleResize() {
        this.handleMediaQueryChange(this.mediaQuery);
    }


    appendHTMLFromTemplate(device) {

        let layer;
        let template;

        // Case 1: If there is desktop video, mobile video, and no forced image
        if (this.v_xl_layer && this.v_xl_template && this.v_sm_layer && this.v_sm_template && this.v_sm_template.dataset.forcedimage == 'false') {
            console.log('Case 1: desktop video, mobile video, no forced image')
            device === 'd' ? (layer = this.v_xl_layer, template = this.v_xl_template) : (layer = this.v_sm_layer, template = this.v_sm_template);
            layer.innerHTML = '';
            const content = template.content.cloneNode(true);
            layer.appendChild(content);
            this.initializeVideo(layer);
        }


        // Case 2: If there is only desktop video, no mobile video and no forced image
        else if (!this.v_sm_layer && this.v_xl_layer && this.v_xl_template && (!this.v_sm_template || this.v_sm_template.dataset.forcedimage == 'false')) {
            console.log('Case 2: desktop video, no mobile video, no forced image')
            layer = this.v_xl_layer;
            template = this.v_xl_template;
            layer.innerHTML = '';
            const content = template.content.cloneNode(true);
            layer.appendChild(content);
            this.initializeVideo(layer);
        }


        // Case 3: If there is no desktop video but mobile video and no forced image
        else if (!this.v_xl_layer && this.v_sm_layer && this.v_sm_template && this.v_sm_template.dataset.forcedimage == 'false') {
            console.log('Case 3: no desktop video, mobile video, no forced image')
            layer = this.v_sm_layer;
            template = this.v_sm_template;
            layer.innerHTML = '';
            const content = template.content.cloneNode(true);
            layer.appendChild(content);
            this.initializeVideo(layer);

        }


        // Case 4: If there is no desktop video but mobile video + force mobile image
        else if (!this.v_xl_layer && this.v_sm_layer && this.v_sm_template && this.v_sm_template.dataset.forcedimage == 'true') {
            console.log('Case 4: no desktop video, mobile video, forced image')
            layer = this.v_sm_layer;
            template = this.v_sm_template;
            const content = template.content.cloneNode(true);
            const smVideo = content.querySelector('video');
            const smImage = content.querySelector('img');
            layer.innerHTML = '';
            device === 'd' ? layer.appendChild(smVideo) : layer.appendChild(smImage);
            if (smVideo) {
                this.initializeVideo(layer);
            }
        }


        // Case 5: If there is desktop video, no mobile video + force mobile image
        else if (this.v_xl_layer && this.v_xl_template && !this.v_sm_layer && this.v_sm_template && this.v_sm_template.dataset.forcedimage == 'true') {
            console.log('Case 5: desktop video, no mobile video, forced image')
            if (device === 'd') {
                layer = this.v_xl_layer;
                template = this.v_xl_template;
            } else {
                layer = this.v_xl_layer;
                template = this.v_sm_template;
            }

            layer.innerHTML = '';
            const content = template.content.cloneNode(true);
            layer.appendChild(content);
            this.initializeVideo(layer);
        }

        // Case 6: If there is desktop video, mobile video, and a forced image
        else if (this.v_xl_layer && this.v_xl_template && this.v_sm_layer && this.v_sm_template && this.v_sm_template.dataset.forcedimage == 'true') {
            console.log('Case 6: desktop video, mobile video, forced image')
            if (device === 'd') {
                layer = this.v_xl_layer;
                template = this.v_xl_template;
                layer.innerHTML = '';
                const content = template.content.cloneNode(true);
                layer.appendChild(content);
                this.initializeVideo(layer);
            } else {
                layer = this.v_sm_layer;
                template = this.v_sm_template;
                const content = template.content.cloneNode(true);
                const smImage = content.querySelector('img');
                layer.innerHTML = '';
                layer.appendChild(content);
                // For mobile with forced image, check if there's a video element
                this.initializeVideo(layer);
            }

        }

    }


    initializeVideo(layer) {
        const video = layer.querySelector('video');
        if (!video) return;

        // Ensure video is muted for autoplay policies
        video.muted = true;

        // Function to attempt playing the video
        const attemptPlay = () => {
            if (video.hasAttribute('autoplay')) {
                const playPromise = video.play();

                if (playPromise !== undefined) {
                    playPromise
                        .then(() => {
                            // Video started playing successfully
                            console.log('Video autoplay started');
                        })
                        .catch(error => {
                            // Autoplay was prevented by browser policy
                            console.log('Video autoplay prevented:', error);
                            // Optionally show controls if autoplay fails
                            if (!video.hasAttribute('controls')) {
                                video.setAttribute('controls', '');
                            }
                        });
                }
            }
        };

        // If video is already loaded, try to play immediately
        if (video.readyState >= 2) { // HAVE_CURRENT_DATA or higher
            attemptPlay();
        } else {
            // Wait for video to be ready
            video.addEventListener('loadeddata', attemptPlay, { once: true });
            video.addEventListener('canplay', attemptPlay, { once: true });
            // Fallback: try after a short delay
            setTimeout(attemptPlay, 100);
        }
    }


}
customElements.define('banner-video', BannerVideo);